export const UNINITIALIZED = 'UNINITIALIZED';
export const LOADING = 'LOADING';
export const SUCCEEDED = 'SUCCEEDED';
export const FAILED = 'FAILED';
export const UPDATING = 'UPDATING';